import React, { FC } from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import ProductSuggestionsShowcase from './ProductSuggestionsShowcase'
import { getBestSellers, getPromotions } from './service'
import { SuggestionTypes } from './typings'

import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { simulationAddressSelector } from '@/checkout-instore-legacy/cart/simulation/selectors'

export interface ProductSuggestionsShowcaseContainerProps {
  suggestionType: SuggestionTypes
  simulationAddress: Address
  intl: any
}

type Props = ProductSuggestionsShowcaseContainerProps

const ProductSuggestionsShowcaseContainer: FC<Props> = ({
  suggestionType,
  simulationAddress,
  intl,
}) => {
  const titles = defineMessages({
    bestsellersTitle: {
      id: 'bestsellers',
    },
    releasesTitle: {
      id: 'releases',
    },
    promotionsTitle: {
      id: 'promotions',
    },
  })

  switch (suggestionType) {
    case SuggestionTypes.BestSellers:
      return (
        <ProductSuggestionsShowcase
          title={intl.formatMessage(titles.bestsellersTitle)}
          getSuggestions={getBestSellers}
          simulationAddress={simulationAddress}
        />
      )

    case SuggestionTypes.Promotions:
      return (
        <ProductSuggestionsShowcase
          title={intl.formatMessage(titles.promotionsTitle)}
          getSuggestions={getPromotions}
          simulationAddress={simulationAddress}
        />
      )

    default:
      return null
  }
}

const mapStateToPropsSelector = createStructuredSelector({
  simulationAddress: simulationAddressSelector,
})

export default injectIntl(
  connect(mapStateToPropsSelector, null)(ProductSuggestionsShowcaseContainer)
)
